import { CLEAR_REIMBURSABLE_EXPENSE, RESET_REIMBURSABLE_EXPENSES, RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP, SELECT_REIMBURSABLE_EXPENSE } from '@Actions/reimbursableExpensesActions';
export const defaultState = {
    selectedExpense: null,
    loading: false,
    lastLoadedTimestamp: new Date()
};
export function reimbursableExpensesReducer(state = defaultState, action) {
    switch (action.type) {
        case RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP: {
            return Object.assign(Object.assign({}, state), { lastLoadedTimestamp: new Date() });
        }
        case RESET_REIMBURSABLE_EXPENSES: {
            return Object.assign(Object.assign({}, defaultState), { lastLoadedTimestamp: state.lastLoadedTimestamp });
        }
        case SELECT_REIMBURSABLE_EXPENSE: {
            return Object.assign(Object.assign({}, state), { selectedExpense: action.payload });
        }
        case CLEAR_REIMBURSABLE_EXPENSE: {
            return Object.assign(Object.assign({}, state), { selectedExpense: null });
        }
        default:
            return state;
    }
}
